import { useEffect } from 'react';
import style from '../components/strategyProject/tabs/TabResults/TabResults.module.less';

export function useOutsideBounder(ref) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target) && ref.current.classList.contains(style.get)) {
        ref.current.classList.remove(style.get);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

export function useOutsideClick(refs, handleClick) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (!refs.some(ref => ref.current && ref.current.contains(event.target))) {
        handleClick()
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [refs]);
}